namespace GeniuzPOS.Lookups {
    export interface VwUsernameRow {
        UserId?: number;
        Username?: string;
        ShopId?: string;
        DisplayName?: string;
        Email?: string;
        Source?: string;
        PasswordHash?: string;
        PasswordSalt?: string;
        LastDirectoryUpdate?: string;
        UserImage?: string;
        MobilePhoneNumber?: string;
        MobilePhoneVerified?: boolean;
        TwoFactorAuth?: number;
        InsertDate?: string;
        InsertUserId?: number;
        UpdateDate?: string;
        UpdateUserId?: number;
        IsActive?: number;
        SupplCode?: string;
        PasswordChangeDate?: string;
        UserActive?: number;
        UserErrorStampFg?: number;
        CheckPasswordUpdate?: string;
    }

    export namespace VwUsernameRow {
        export const idProperty = 'Username';
        export const nameProperty = 'Username';
        export const localTextPrefix = 'Lookups.VwUsername';
        export const lookupKey = 'Lookups.VwUsername';

        export function getLookup(): Q.Lookup<VwUsernameRow> {
            return Q.getLookup<VwUsernameRow>('Lookups.VwUsername');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            UserId = "UserId",
            Username = "Username",
            ShopId = "ShopId",
            DisplayName = "DisplayName",
            Email = "Email",
            Source = "Source",
            PasswordHash = "PasswordHash",
            PasswordSalt = "PasswordSalt",
            LastDirectoryUpdate = "LastDirectoryUpdate",
            UserImage = "UserImage",
            MobilePhoneNumber = "MobilePhoneNumber",
            MobilePhoneVerified = "MobilePhoneVerified",
            TwoFactorAuth = "TwoFactorAuth",
            InsertDate = "InsertDate",
            InsertUserId = "InsertUserId",
            UpdateDate = "UpdateDate",
            UpdateUserId = "UpdateUserId",
            IsActive = "IsActive",
            SupplCode = "SupplCode",
            PasswordChangeDate = "PasswordChangeDate",
            UserActive = "UserActive",
            UserErrorStampFg = "UserErrorStampFg",
            CheckPasswordUpdate = "CheckPasswordUpdate"
        }
    }
}
